import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <span>Dashboard</span>
    </div>
  );
};

export default Dashboard;
